import { CiCalendarDate } from "react-icons/ci";

import { Button } from "@/components/ui/button/button";
import { useEmpAttendanceModal } from "./customized-calendar/use-attendance-modal";
import { EmployeeAttendanceModal } from "./customized-calendar/attendance-modal";

export const EmployeeAttendances = () => {
  const { onOpenChange } = useEmpAttendanceModal();

  return (
    <div className="w-60 min-h-24 rounded-md bg-card flex flex-col gap-1 justify-between shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Employee Attendance</h2>

        <CiCalendarDate className="w-4 h-4" />
      </div>
      <div className="">
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>
      </div>
      <EmployeeAttendanceModal />
    </div>
  );
};
